import http from '../APIs/olonaTeams'

export default class CommentAPI {
    // comment
  public addComment = (data: any, token: any) => http.post(`/comment`, data, token)

  public getComment = (id: string | number, token: any) => http.get(`/comment/${id}`, token)
}